import i18n from "../../../../../i18n";
import { FIFTH_FLOOR_CD_IMG } from "../../floor_images";
import elevator from "../../elevator_positions";

let locations;
export default locations = [
  // {
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   floor: i18n.t("fifth_floor"),
  //   title: "518",
  //   marked_position_x: 189,
  //   marked_position_y: 129,
  // },
  // {
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   floor: i18n.t("fifth_floor"),
  //   title: "519",
  //   marked_position_x: 202,
  //   marked_position_y: 106,
  // },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "520",
    marked_position_x: 210,
    marked_position_y: 88,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "521",
    marked_position_x: 231,
    marked_position_y: 92,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "522",
    marked_position_x: 256,
    marked_position_y: 97,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "524",
    marked_position_x: 275,
    marked_position_y: 99,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "525",
    marked_position_x: 294,
    marked_position_y: 99,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "526",
    marked_position_x: 317,
    marked_position_y: 102,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "527",
    marked_position_x: 310,
    marked_position_y: 128,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "529",
    marked_position_x: 316,
    marked_position_y: 148,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "530",
    marked_position_x: 307,
    marked_position_y: 167,
  },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "531",
    marked_position_x: 297,
    marked_position_y: 199,
  },
  // {
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   floor: i18n.t("fifth_floor"),
  //   title: "532",
  //   marked_position_x: 274,
  //   marked_position_y: 186,
  // },
  // {
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   floor: i18n.t("fifth_floor"),
  //   title: "533",
  //   marked_position_x: 230,
  //   marked_position_y: 173,
  // },
  {
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    floor: i18n.t("fifth_floor"),
    title: "534",
    marked_position_x: 193,
    marked_position_y: 183,
  },
];
